/* KOR-E FAQ accordion — extracted from sections/kore-faq-with-media.liquid (Batch AR). */
(function () {
  /* Theme Editor double-binding guard (Batch AS). A section reload fires BOTH the
     re-rendered section's own bootstrap push AND the previous run's
     shopify:section:load handler, so init() used to bind two click listeners to the
     same new nodes — one tap then toggled a question open and shut again. Measured:
     aria-expanded false -> false on a single click after a reload. This existed in the
     original inline script too; it is not a side effect of the extraction.
     Fixed on two axes: mark the root element so binding is idempotent (a genuine
     re-render brings a fresh root, so real re-inits still work), and register the
     section:load listener once per section id so listeners cannot accumulate. */
  var LISTENER_BOUND = {};
  function init(cfg) {

  'use strict';
  var SID = cfg.sid;

  function init() {
    var root = document.getElementById('kore-faq-' + SID);
    if (!root) return;
    if (root._koreFaqBound) return;
    root._koreFaqBound = true;

    var accordion   = root.querySelector('.kfaq__accordion');
    var allowMulti  = accordion && accordion.dataset.allowMultiple === 'true';
    var items       = root.querySelectorAll('.kfaq__item');

    /* Enable transitions only after initial render so pre-opened items don't animate in */
    requestAnimationFrame(function () {
      root.classList.add('kfaq--ready');
    });

    items.forEach(function (item) {
      var btn    = item.querySelector('.kfaq__question');
      var answer = item.querySelector('.kfaq__answer');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        /* Close all others when multiple not allowed */
        if (!allowMulti) {
          items.forEach(function (other) {
            if (other !== item && other.classList.contains('is-open')) {
              other.classList.remove('is-open');
              var ob = other.querySelector('.kfaq__question');
              var oa = other.querySelector('.kfaq__answer');
              if (ob) ob.setAttribute('aria-expanded', 'false');
              if (oa) oa.setAttribute('aria-hidden', 'true');
            }
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  /* Re-init when section is reloaded in Theme Editor */
  if (window.Shopify && Shopify.designMode && !LISTENER_BOUND[SID]) {
    LISTENER_BOUND[SID] = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('#kore-faq-' + SID)) init();
    });
  }

  }
  function boot() { var q = window.__koreFAQ || []; (q.forEach ? q : []).forEach(init); window.__koreFAQ = { push: init }; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
}());
